import { render, staticRenderFns } from "./loginSign.vue?vue&type=template&id=1ecd5281&scoped=true&"
import script from "./loginSign.vue?vue&type=script&lang=js&"
export * from "./loginSign.vue?vue&type=script&lang=js&"
import style0 from "./loginSign.vue?vue&type=style&index=0&id=1ecd5281&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd5281",
  null
  
)

export default component.exports